import _property from 'lodash/property'

const fhirIdToken = _property('fhirIdToken')
const fhirAccessToken = _property('fhirAccessToken')
const fhirRefreshToken = _property('fhirRefreshToken')

export default {
  fhirIdToken,
  fhirAccessToken,
  fhirRefreshToken
}
